jQuery(document).ready(function($) {

    $( ".bloc_liens" ).each(function( index ) {

        var bloc = $(this)
        var parent = $(this).find(".acces")
        var cibleAcces = parent.find(".anim")

        var mm = gsap.matchMedia()

        // Desktop : montée en cascade liée au scroll
        mm.add("(min-width: 1024px)", function() {
            gsap.from( cibleAcces, {
                y : +200,
                duration: 1,
                stagger: .2,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: parent,
                    markers: false,
                    start: "top 100%",
                    end: "top 50%",
                    scrub: 1,
                }

            })
        })

        // Tablette / mobile : les éléments sont empilés, chacun apparaît
        // à son arrivée à l'écran (un décalage commun de 200px ferait chevaucher les lignes)
        mm.add("(max-width: 1023.98px)", function() {
            cibleAcces.each(function() {
                gsap.from(this, {
                    y: 60,
                    duration: .6,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: this,
                        start: "top 95%",
                    }
                })

                // pas de survol au doigt : la tuile qui croise le milieu de l'écran
                // s'éclaire et révèle son texte, comme au survol desktop
                gsap.timeline({
                    scrollTrigger: {
                        trigger: this,
                        start: "top 50%",
                        end: "bottom 50%",
                        toggleClass: {targets: $(this).find("a")[0], className: "is-focus"},
                    }
                })
            })

            // le texte n'est masqué qu'une fois le mécanisme en place (sans JS, il reste visible)
            bloc.addClass("focus-scroll")

            return function() {
                bloc.removeClass("focus-scroll")
                bloc.find(".is-focus").removeClass("is-focus")
            }
        })

    })

});